'use client';

import React from 'react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../primitives/tooltip';

import type { ComponentPropsWithoutRef, ReactNode } from 'react';

export interface UzTooltipProps {
  /** The element that triggers the tooltip. asChild semantics. */
  children: ReactNode;
  /** Tooltip content. */
  label: ReactNode;
  side?: ComponentPropsWithoutRef<typeof TooltipContent>['side'];
  align?: ComponentPropsWithoutRef<typeof TooltipContent>['align'];
  delay?: number;
  /** Set to false to disable globally (e.g., on touch). */
  disabled?: boolean;
}

/**
 * UzTooltip - hover/focus tooltip with sensible defaults.
 *
 * Provider is included so callers can drop in a single component without
 * wiring a global TooltipProvider. If you have many tooltips in one tree,
 * wrap with one TooltipProvider higher up to share state.
 */
export const UzTooltip = ({
  children,
  label,
  side = 'top',
  align = 'center',
  delay = 200,
  disabled,
}: UzTooltipProps): React.JSX.Element => {
  if (disabled) return <>{children}</>;
  return (
    <TooltipProvider delayDuration={delay}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side={side} align={align}>
          {label}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
